import { all } from "redux-saga/effects";

import userSagas from "./userSagas";
import roleGroupSaga from "./roleGroupSaga";
import PersonalSummarySaga from "./PersonalSummarySaga";
import UserGroupSagas from "./userGroupSagas";
import equipmentSaga from "./EquipmentSaga";
import equipmentNotesSaga from "./EquipmentNotesSaga";
import PMSagas from "./PMSagas";
import breakDownTaskSagas from "./breakDownTaskSagas";
import notificationSaga from "./notificationSaga";
import PlannedMaintenanceCalendarSaga from "./PlannedMaintenanceCalendarSaga";
import breakDownDetailSaga from "./BreakDownDetailSaga";
import PlannedMaintenanceDetailSaga from "./PlannedMaintenanceDetailSaga";
import PlannedMaintenanceListSaga from "./PlannedMaintenanceListSaga";
import AutonomousMaintenanceCalendarSaga from "./AutonomousMaintenanceCalendarSaga";
import AutonomousMaintenanceListSaga from "./AutonomousMaintenanceListSaga";
import AutonomousMaintenanceDetailSaga from "./AutonomousMaintenanceDetailSaga";
import CheckItemGroupSaga from "./CheckItemGroupSaga";
import operatorMainPageSaga from "./OperatorMainPageSaga";
import operatorRequestSaga from "./OperatorRequestSaga";
import AMSagas from "./AMSagas";
import poolSaga from "./PoolSaga";
import ReportBreakDownSagas from "./ReportBreakDownSaga";
import generalTableSaga from "./GeneralTableSaga";
import breakDownListTableSaga from "./BreakdownListTableSaga";
import AutonomousMaintenanceOrderTaskSaga from "./AutonomousMaintenanceOrderTasksSaga";
import MasterDataSaga from "./MasterDataSaga";
import OrderFormSaga from "./OrderFormSaga";
import MailGroupsSaga from "./MailGroupsSaga";
import CustomListSaga from "./CustomListSaga";
import TechnicianMainPageSaga from "./TechnicianMainPageSaga";
import LocalizationDataSaga from "./LocalizationDataSaga";
import CheckItemGroupExcelSaga from "./CheckItemGroupExcelSaga";
import CreateMultiplePMSaga from "./CreateMultiplePMSaga";
import PlannedMaintenanceUpdateSaga from "./PlannedMaintenanceUpdateSaga";
import ToBePlannedSaga from "./ToBePlannedSaga";
import SingleMaintenanceUpdateSaga from "./SingleMaintenanceUpdateSaga";
import EkedEquipmentSaga from "./EkedEquipmentSaga";
import BreakdownReasonPlaceSaga from "./BreakdownReasonPlaceSaga";
import BreakdownReasonDetailSaga from "./BreakdownReasonDetailSaga";
import MaintenanceTypeSaga from "./MaintenanceTypeSaga";
import BreakdownEffectSaga from "./BreakdownEffectSaga";
import breakdownReasonGroupSaga from "./BreakdownReasonGroupSaga";
import MachineMaintenanceSummaryListSaga from "./MachineMaintenanceSummaryListSaga";
import MachineMaintenanceSummaryListPlannedSaga from "./MachineMaintenanceSummaryListPlannedSaga";
import plantSaga from "./PlantSaga";
import ShiftSaga from "./ShiftSagas";
import ShiftPlanSaga from "./ShiftPlansSaga";
import equipmentReportSaga from "./EquipmentReportSaga";
import SparePartSaga from "./SparePartSaga";
import SparePartExcelSaga from "./SparePartExcelSaga";
import EwoSaga from "./EwoSaga";
import RootCausesFamilyAndOptionsSaga from "./RootCauseFamilyAndOptionsSaga";


export default function* rootSaga() {
    yield all([
        ...userSagas,
        ...roleGroupSaga,
        ...PersonalSummarySaga,
        ...UserGroupSagas,
        ...PMSagas,
        ...AMSagas,
        ...equipmentSaga,
        ...equipmentNotesSaga,
        ...breakDownTaskSagas,
        ...notificationSaga,
        ...PlannedMaintenanceCalendarSaga,
        ...breakDownDetailSaga,
        ...PlannedMaintenanceDetailSaga,
        ...PlannedMaintenanceListSaga,
        ...AutonomousMaintenanceCalendarSaga,
        ...AutonomousMaintenanceDetailSaga,
        ...AutonomousMaintenanceListSaga,
        ...CheckItemGroupSaga,
        ...operatorMainPageSaga,
        ...operatorRequestSaga,
        ...poolSaga,
        ...ReportBreakDownSagas,
        ...generalTableSaga,
        ...breakDownListTableSaga,
        ...AutonomousMaintenanceOrderTaskSaga,
        ...MasterDataSaga,
        ...OrderFormSaga,
        ...MailGroupsSaga,
        ...CustomListSaga,
        ...TechnicianMainPageSaga,
        ...LocalizationDataSaga,
        ...CheckItemGroupExcelSaga,
        ...CreateMultiplePMSaga,
        ...PlannedMaintenanceUpdateSaga,
        ...ToBePlannedSaga,
        ...SingleMaintenanceUpdateSaga,
        ...EkedEquipmentSaga,
        ...BreakdownReasonPlaceSaga,
        ...BreakdownReasonDetailSaga,
        ...MaintenanceTypeSaga,
        ...BreakdownEffectSaga,
        ...breakdownReasonGroupSaga,
        ...MachineMaintenanceSummaryListSaga,
        ...MachineMaintenanceSummaryListPlannedSaga,
        ...plantSaga,
        ...ShiftSaga,
        ...ShiftPlanSaga,
        ...equipmentReportSaga,
        ...SparePartSaga,
        ...SparePartExcelSaga,
        ...EwoSaga,
        ...RootCausesFamilyAndOptionsSaga
    ]);
}
